import { canCreatePage, canUpdatePage } from "../util/pagePermissions";

// Tanımlama sayfasını açan Ekle/Güncelle butonları için kullanıcı yetkisi. Yetkiler util/pagePermissions.js
// içindeki DEFINITION_PAGE_PERMISSIONS'tan okunur: yeni kayıt create, düzenleme update yetkisi ister.
export default {
  data() {
    return {
      noPermissionMessage: "Bu işlem için yetkiniz bulunmamaktadır.",
    };
  },
  methods: {
    canCreateDefinitionPage(path) {
      return canCreatePage(path, this.$store.getters.getUserPermissions);
    },
    canUpdateDefinitionPage(path) {
      return canUpdatePage(path, this.$store.getters.getUserPermissions);
    },
  },
};
